import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {GetSuggestedIssueFieldsResponse} from './contracts'

export async function apiGetSuggestedIssueFields(): Promise<GetSuggestedIssueFieldsResponse> {
  const apiData = getApiMetadata('memex-suggested-issue-fields-api-data')
  const {data} = await fetchJSONWith<GetSuggestedIssueFieldsResponse>(apiData.url)
  return data
}
